import { NavLink } from "react-router-dom";
import { NAV_ITEMS } from "@/components/navConfig";
import { Brand } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";

export function Sidebar() {
  const { user, logout } = useAuth();
  return (
    <aside
      className="hidden lg:flex flex-col fixed inset-y-0 left-0 w-64 bg-white border-r border-gray-200 z-30"
      data-testid="sidebar"
    >
      <div className="px-6 py-6 border-b border-gray-100">
        <Brand size="sm" />
      </div>

      <nav className="flex-1 px-3 py-5 space-y-1 overflow-y-auto">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.key}
              to={item.path}
              data-testid={`nav-${item.key}`}
              className={({ isActive }) =>
                `group flex items-center gap-3 px-3.5 py-2.5 rounded-md text-sm font-semibold transition-colors duration-150 ${
                  isActive
                    ? "bg-brand-yellow text-brand-graphite"
                    : "text-brand-gray hover:bg-gray-50"
                }`
              }
            >
              <Icon className="h-[18px] w-[18px] shrink-0" strokeWidth={2} />
              {item.label}
            </NavLink>
          );
        })}
      </nav>

      <div className="px-3 py-4 border-t border-gray-100">
        <div className="px-3 pb-3">
          <p className="text-xs text-brand-gray/60 font-medium uppercase tracking-wider">Organización</p>
          <p className="text-sm font-bold text-brand-graphite mt-0.5">{user?.organization_name}</p>
        </div>
        <button
          onClick={logout}
          data-testid="logout-button"
          className="w-full flex items-center gap-3 px-3.5 py-2.5 rounded-md text-sm font-semibold text-brand-gray hover:bg-gray-50 transition-colors"
        >
          <LogOut className="h-[18px] w-[18px]" strokeWidth={2} />
          Cerrar sesión
        </button>
      </div>
    </aside>
  );
}
